// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgElevator = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path d="M15.25 2H4.75A2.75 2.75 0 0 0 2 4.75v10.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25V4.75A2.75 2.75 0 0 0 15.25 2Zm1.25 13.25a1.25 1.25 0 0 1-1.25 1.25H4.75a1.25 1.25 0 0 1-1.25-1.25V4.75A1.25 1.25 0 0 1 4.75 3.5h10.5a1.25 1.25 0 0 1 1.25 1.25v10.5Z" />
    <path d="M10.53 5.38a.75.75 0 0 0-1.06 0L7.24 7.6a.75.75 0 0 0 0 1.06.74.74 0 0 0 1.06 0L10 6.97l1.7 1.7c.14.14.331.22.53.22a.79.79 0 0 0 .53-.22.75.75 0 0 0 0-1.06l-2.23-2.23ZM11.7 11.34l-1.7 1.7-1.7-1.7a.75.75 0 0 0-1.06 1.06l2.23 2.23a.79.79 0 0 0 .53.22.77.77 0 0 0 .53-.22l2.23-2.23a.75.75 0 0 0-1.06-1.06Z" />
  </svg>
)

export default SvgElevator
